import React, { useEffect, useState } from "react";
import styles from "./school-classes.module.css";
import { Typography } from "antd";
import CustomTable from "../../../../../../../common/custom-table/custom-table";
import SVGIcon from "../../../../../../../constants/SVGIcon";
import { fetchClass } from "../../../../../../../services/student";
import AddEditClasses from "./components/add-edit-classes/add-edit-classes";

const SchoolClasses = () => {
  const [levels, setLevels] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [editDetails, setEditDetails] = useState(null);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    setPageNo(1);
    getLevels();
  }, []);

  const getLevels = async (tempPage = pageNo, tempPageSize = pageSize) => {
    try {
      setLoading(true);
      const payload = {
        page: tempPage,
        pageSize: tempPageSize,
      };
      const response = await fetchClass(payload);
      if (response?.data) {
        const data = response?.data?.data?.levels;
        setLevels(data);
        setTotalCount(response?.data?.data?.totalRecords);
      }
      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  const handleChangePage = (page, pageSize) => {
    setPageNo(page);
    setPageSize(pageSize);
    getLevels(page, pageSize);
  };

  const handleEditClasses = (data) => {
    setEditDetails(data);
    setOpenDrawer(true);
  };

  const handleOnClose = () => {
    getLevels();
    setOpenDrawer(false);
  };

  const columns = [
    {
      title: "Level Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a?.name?.localeCompare(b?.name),
      render: (value) => value || "-",
    },
    {
      title: "Classes",
      dataIndex: "classRooms",
      key: "classRooms",
      sorter: (a, b) => {
        const aClasses = a?.classRooms?.map(c => c?.name).join(", ") || "";
        const bClasses = b?.classRooms?.map(c => c?.name).join(", ") || "";
        return aClasses?.localeCompare(bClasses);
      },
      render: (value) => value?.length > 0 ? value?.map(item => item?.name).join(", ") : "-",
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (_, record) => (
        <div className={styles.actionItemWrapper}>
          <SVGIcon
            name={"edit-icon"}
            width={"20"}
            height={"20"}
            stroke={"#3BB44B"}
            onClick={() => handleEditClasses(record)}
          />
        </div>
      ),
    },
  ];

  return (
    <div>
      <div className={styles.titleContainer}>
        <Typography className={styles.tabTitle}>
          Classes
        </Typography>
      </div>

      <div className={styles.tableContainer}>
        <CustomTable
          columns={columns}
          dataSource={levels}
          loading={loading}
          headerColor="#667085"
          headerBackgroundColor="#F9FAFB"
          total={totalCount}
          pageSize={pageSize}
          currentPage={pageNo}
          handlePageChange={handleChangePage}
        />
      </div>
      <AddEditClasses
        open={openDrawer} 
        onClose={handleOnClose} 
        data={editDetails}
      />
    </div>
  );
};

export default SchoolClasses;